/* CardCover.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1xC2CJiObl%7Bgrid-area%3Acover%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1mT5xdRAKS%7Bposition%3Arelative%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02N91d%7Bwidth%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VmdCj%7Bheight%3A56px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1mT5xdWVPG%7Bposition%3Aabsolute%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2I62gzPgdg%7Binset-block-start%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1ZB6Uy5zaO%7Binset-block-end%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iC0zdPgdg%7Binset-inline-start%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1OKFqYPgdg%7Binset-inline-end%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VIZbP%7Bheight%3Aauto%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3OqcjTWxuo%7Bbackground-size%3A1pc%201pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1DJ2rVphmj%7Bbackground-position%3A-1px%20-1px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._46hvQm5zaO%7Bpadding-block-start%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2Y7lL45zaO%7Bpadding-inline%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._24h04i2Njc%7Bbox-sizing%3Aborder-box%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbgBM8%7Bdisplay%3Agrid%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VN91d%7Bheight%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2iEGP2cMcx%7Bgrid-template-columns%3Aauto%20minmax(0%2C1fr)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0ca6V7IZbP%7Bgrid-template-rows%3Aauto%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3NN0tO0GnG%7Bgrid-template-areas%3A%22avatar%20content%22%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0GwItXDIqT%7Balign-content%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0hPCNLDIqT%7Balign-items%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._17lj8p2ADO%7B-moz-column-gap%3Avar(--ds-space-100%2C8px)%3Bcolumn-gap%3Avar(--ds-space-100%2C8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._46hvQmkG2W%7Bpadding-block-start%3Avar(--ds-space-250%2C20px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1xC2CJNoyG%7Bgrid-area%3Aavatar%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4xdlr0DIqT%7Balign-self%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2p6ht9DIqT%7Bjustify-self%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1xC2CJa6YE%7Bgrid-area%3Acontent%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._42Yu6Bbhqd%7Bz-index%3A200%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2p6ht9F05b%7Bjustify-self%3Aend%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4ouGXIdnbC%7Bmin-width%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0pI6nMF05b%7Bjustify-items%3Aend%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1xC2CJYhv7%7Bgrid-area%3A1%2F1%7D");
import React from 'react';
import Avatar from '@atlaskit/avatar/avatar';
import { cx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
export type CardCoverStyle = 'grid' | 'gradient' | 'plain';
export type CardCoverProps = {
  name: string;
  avatar?: React.ComponentType<{
    name: string;
    iconUrl?: string;
  }>;
  coverStyle?: CardCoverStyle;
  coverColor?: string;
  children?: React.ReactNode;
  badge?: React.ReactNode;
  iconUrl?: string;
  testId?: string;
};
const DEFAULT_COVER_COLOR = "var(--ds-background-accent-green-subtlest, #DCFFF1)";
const DEFAULT_GRID_LINE = "var(--ds-border, #0B120E24)";
const DEFAULT_GRID_LINE_WIDTH = '0.3px';
const BACKGROUND_STYLES: Record<Exclude<CardCoverStyle, 'plain'>, string> = {
  grid: `linear-gradient(${DEFAULT_GRID_LINE} ${DEFAULT_GRID_LINE_WIDTH}, transparent ${DEFAULT_GRID_LINE_WIDTH}), linear-gradient(90deg, ${DEFAULT_GRID_LINE} ${DEFAULT_GRID_LINE_WIDTH}, transparent ${DEFAULT_GRID_LINE_WIDTH})`,
  gradient: 'linear-gradient(90deg, rgb(255 255 255 / 0.25) 0%, rgb(255 255 255 / 0) 70%)'
};
const styles = {
  root: "_1xC2CJiObl _1mT5xdRAKS _39xV02N91d _0jFU0VmdCj",
  background: "_1mT5xdWVPG _2I62gzPgdg _1ZB6Uy5zaO _3iC0zdPgdg _1OKFqYPgdg _39xV02N91d _0jFU0VIZbP",
  gridBackground: "_3OqcjTWxuo _1DJ2rVphmj",
  plainRoot: "_0jFU0VIZbP",
  plainForeground: "_46hvQm5zaO",
  foreground: "_2Y7lL45zaO _24h04i2Njc _3iDTPbgBM8 _39xV02N91d _0jFU0VN91d _2iEGP2cMcx _0ca6V7IZbP _3NN0tO0GnG _0GwItXDIqT _0hPCNLDIqT _17lj8p2ADO _46hvQmkG2W",
  avatar: "_1xC2CJNoyG _4xdlr0DIqT _2p6ht9DIqT",
  content: "_1xC2CJa6YE _1mT5xdRAKS _42Yu6Bbhqd _2p6ht9F05b _4ouGXIdnbC",
  slot: "_3iDTPbgBM8 _0pI6nMF05b _0hPCNLDIqT",
  layer: "_1xC2CJYhv7"
};
const DefaultAvatar = ({
  name,
  iconUrl
}: {
  name: string;
  iconUrl?: string;
}): React.JSX.Element => <Avatar name={name} src={iconUrl} size="small" />;
export const CardCover = ({
  name,
  avatar: AvatarComponent = DefaultAvatar,
  coverStyle = 'grid',
  coverColor,
  children,
  badge,
  iconUrl,
  testId
}: CardCoverProps): React.JSX.Element => {
  const trailing = badge ?? children;
  const overlay = Boolean(badge && children);
  return <Box xcss={cx(styles.root, coverStyle === 'plain' && styles.plainRoot)} testId={testId}>
			{coverStyle === 'plain' ? null : <Box xcss={cx(styles.background, coverStyle === 'grid' && styles.gridBackground)} aria-hidden="true" style={{
      backgroundColor: coverColor ?? DEFAULT_COVER_COLOR,
      backgroundImage: BACKGROUND_STYLES[coverStyle]
    }} />}
			<Box xcss={cx(styles.foreground, coverStyle === 'plain' && styles.plainForeground)}>
				<Box xcss={styles.avatar}>
					<AvatarComponent name={name} iconUrl={iconUrl} />
				</Box>
				{overlay ? <Box xcss={cx(styles.content, styles.slot)}>
						<Box xcss={styles.layer}>{badge}</Box>
						<Box xcss={styles.layer}>{children}</Box>
					</Box> : trailing ? <Box xcss={styles.content}>{trailing}</Box> : null}
			</Box>
		</Box>;
};